import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'components/ui';
import {MissingQuestion} from 'APIs/letrusAPI/questionnaire/types';
import {useMobile} from 'utils/hooks';
import styles from './PracticeTestMissingQuestionsModal.module.scss';

export interface PracticeTestMissingQuestionsModalProps {
  missingQuestions: MissingQuestion[];
  onGoBack(): void;
  onClose(): void;
}

function PracticeTestMissingQuestionsModal({
  missingQuestions,
  onGoBack,
  onClose,
}: PracticeTestMissingQuestionsModalProps): JSX.Element {
  const {isMobile} = useMobile();
  const questionNumbers = missingQuestions.map((question) => question.order);
  const formattedNumbers = questionNumbers.join(', ');

  return (
    <Modal
      isOpen
      onClose={onClose}
      vw={!isMobile ? 70 : 100}
      maxWidth={440}
      maxHeight={480}
      clickOutsideToClose={false}
    >
      <div
        className={styles.PracticeTestMissingQuestionsModal}
        data-testid="practice-test-missing-questions-modal"
      >
        <FontAwesomeIcon size="3x" icon="circle-exclamation" color="#C4444D" />

        <div className={styles.content}>
          <h3>Atenção</h3>

          <p>
            Você ainda tem{' '}
            <strong>
              {questionNumbers.length}{' '}
              {questionNumbers.length === 1 ? 'questão' : 'questões'}
            </strong>{' '}
            sem resposta. Para avançar para a próxima etapa, todas as perguntas
            precisam estar respondidas.
          </p>

          <strong>
            {questionNumbers.length === 1
              ? `Questão pendente: ${formattedNumbers}`
              : `Questões pendentes: ${formattedNumbers}`}
          </strong>

          {questionNumbers.length === 1 ? (
            <p>
              Ao clicar no botão abaixo, você será redirecionado para a questão
              sem resposta.
            </p>
          ) : (
            <p>
              Ao clicar no botão abaixo, você será redirecionado para a primeira
              questão sem resposta. Lembre-se de verificar as demais também.
            </p>
          )}
        </div>

        <Button
          text="Voltar para o questionário"
          onClick={onGoBack}
          variant="primary"
        />
      </div>
    </Modal>
  );
}

export default PracticeTestMissingQuestionsModal;
